export const LOCAL_STORAGE_KEY = {
  AUTH_TOKEN: 'token',
  REFRESH_TOKEN: 'refresh',
  MFA_TOKEN: 'mfa_token',
  MFA_DEVICE_ID: 'device_id',
  FROM_LOCATION: 'fromLocation',
  FEEDBACKS: 'feedbacks',
  FEEDBACK_DRAFTS: 'feedbackDrafts',
  PROJECT: 'project',
  HIDE_MAINTENANCE_WARNING: 'hideMaintenanceWarning',
};

export const STRING_STORAGE_VALUE_OPTIONS = {
  serializer: (value) => value,
  deserializer: (value) => value,
  initializeWithValue: true,
};
